/** Read-only live floor status from bookings + dine-in orders. */
const ACTIVE_BOOKING = new Set(["unconfirmed", "confirmed", "seated"]);
const ACTIVE_ORDER = new Set(["unconfirmed", "awaiting_payment", "confirmed", "ready"]);
export function bookingUsesTable(b, tableId) {
    return (b.table_ids || []).includes(tableId);
}
export function orderUsesTable(o, tableId) {
    if (o.config?.service !== "dine_in")
        return false;
    return o.config.table_id === tableId;
}
function orderToFloorStatus(status) {
    if (status === "ready")
        return "ready";
    if (status === "unconfirmed" || status === "awaiting_payment")
        return "needs_order";
    return "confirmed";
}
function bookingToFloorStatus(status) {
    if (status === "seated")
        return "seated";
    if (status === "confirmed")
        return "confirmed";
    if (status === "unconfirmed")
        return "unconfirmed";
    return "open";
}
/** Later booking today still counts as reserved when not yet active. */
function isFutureBooking(b, nowMs) {
    return b.config.timestamp > nowMs + 15 * 60 * 1000;
}
export function resolveFloorTableLiveState(tableId, bookings, orders, nowMs = Date.now()) {
    const order = orders.find((o) => ACTIVE_ORDER.has(o.status) && orderUsesTable(o, tableId));
    if (order) {
        const status = orderToFloorStatus(order.status);
        return {
            status,
            label: status === "needs_order" ? "NEEDS ORDER" : status.toUpperCase(),
            detail: order.config.table || undefined,
        };
    }
    const booking = bookings.find((b) => ACTIVE_BOOKING.has(b.status) &&
        bookingUsesTable(b, tableId) &&
        !isFutureBooking(b, nowMs));
    if (booking) {
        const status = bookingToFloorStatus(booking.status);
        return {
            status,
            label: status === "unconfirmed" ? "UN-CONFIRMED" : status.toUpperCase(),
            detail: booking.customer?.name,
        };
    }
    const reserved = bookings.find((b) => (b.status === "confirmed" || b.status === "unconfirmed") &&
        bookingUsesTable(b, tableId) &&
        isFutureBooking(b, nowMs));
    if (reserved) {
        return {
            status: "reserved",
            label: "RESERVED",
            detail: reserved.customer?.name,
        };
    }
    return { status: "open", label: "OPEN" };
}
export const FLOOR_STATUS_COLORS = {
    open: { bg: "#ffffff", border: "#d5d7da", text: "#414651" },
    unconfirmed: { bg: "#fef9c3", border: "#fde047", text: "#854d0e" },
    confirmed: { bg: "#ecfdf3", border: "#abefc6", text: "#067647" },
    seated: { bg: "#ecfdf3", border: "#abefc6", text: "#067647" },
    needs_order: { bg: "#fffbeb", border: "#fedf89", text: "#b54708" },
    ready: { bg: "#eff6ff", border: "#93c5fd", text: "#1d4ed8" },
    reserved: { bg: "#f8fafc", border: "#94a3b8", text: "#475569" },
};
//# sourceMappingURL=floor_live.js.map